import { Injectable } from '@angular/core';
import { DwMetaDataGridConfig, DwMetaDataGridPreferenceHierarchy, DwMetaDataGridService } from '@devwareapps/devware-cap';
import { environment } from '../../../../environments/environment';

/** Local preview only: preserve the saved CAP query, columns and actions. */
@Injectable()
export class QuizInsightsGridConfigService extends DwMetaDataGridService {
  buildDefaultGridConfig(hierarchy: DwMetaDataGridPreferenceHierarchy, initialViewKey: string, readOnly: boolean): DwMetaDataGridConfig {
    const config = super.buildDefaultGridConfig(hierarchy, initialViewKey, readOnly);
    const flags = environment as { localQuizInsights?: boolean; localQuestionBankRedesign?: boolean; localTagsRedesign?: boolean };
    const renderer = hierarchy.configKey === 'Quiz' && flags.localQuizInsights ? 'quiz-insights-grid-renderer'
      : hierarchy.configKey === 'Question' && flags.localQuestionBankRedesign ? 'question-bank-grid-renderer'
      : hierarchy.configKey === 'QuestionTag' && flags.localTagsRedesign ? 'tags-grid-renderer' : null;
    if (!renderer || !['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)) {
      return config;
    }
    const view = config?.views?.find(v => v.key === 'default');
    if (view) {
      view.gridViewPreferences = {
        ...view.gridViewPreferences,
        gridRendererComponentKey: renderer,
        hideActionAndFiltersUI: true
      };
    }
    return config;
  }
}
